import type { BankAccountProps } from '@api/models/bank-account';
import type { UpdateBankAccountRequest } from '@api/features/bank-accounts/updateBankAccount';
import showSuccessNotification from '@client/utils/showSuccessNotification';
import showErrorNotification from '@client/utils/showErrorNotification';
import {
	deleteBankAccount,
	getVessels,
	updateBankAccount,
	updateVessel,
} from '@client/lib/api';

const useVesselBankAccountHandlers = (
	vesselId: number,
	onChange: () => Promise<unknown> | void,
) => {
	const onSaveBankAccount = async (
		account: BankAccountProps,
		changes: UpdateBankAccountRequest['attributes'],
	) => {
		const vessels = await getVessels();

		vessels.forEach(async (v) => {
			if (changes.companyInvoiceName != null &&
				v.invoiceCompanyNameToUse === account.companyInvoiceName) {
				v.invoiceCompanyNameToUse = changes.companyInvoiceName;

				await updateVessel(v.id, {
					invoiceCompanyNameToUse: changes.companyInvoiceName,
				});
			}
		});

		await updateBankAccount(changes, account.id, vesselId);
		await onChange();
	};

	const onDeleteBankAccount = async (accountId: number) => {
		try {
			await deleteBankAccount(accountId, vesselId);
			showSuccessNotification('Successfully deleted bank account.');
		} catch (error) {
			showErrorNotification('Could not delete bank account', error as Error);

			return;
		}

		await onChange();
	};

	return {
		onSaveBankAccount,
		onDeleteBankAccount,
	};
};

export default useVesselBankAccountHandlers;
